<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <h1 class="title">Manage Forecast State</h1>

  <div class="extra-buttons">
    <button id="update-button" mat-stroked-button color="primary" class="action-button"
            [disabled]="!selectedValue"
            (click)="updateForecastState()">
      Update
    </button>
    <button id="add-button" mat-raised-button color="primary" class="action-button"
            (click)="addForecastState()">
      Add
    </button>
    <button id="delete-button" mat-raised-button color="warn" class="action-button"
            [disabled]="!selectedValue"
            (click)="deleteForecastState()">
      Delete
    </button>
  </div>
</div>
<div class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="forecastStates"
    [columnDefs]="columnDef"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>

